module.exports = __webpack_public_path__ + "static/img/antek_logo_white.aef900c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/antek_logo_white.png
// module id = E104
// module chunks = 26